import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateRangeRequiredValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  if (!value.StartDate || !value.EndDate) {
    return { dateRangeRequiredError: true };
  }

  return null;
}
